<template>
  <div class="ceiling-product-selector">
    <el-table :data="selectedGoods" border style="width: 100%">
      <el-table-column label="商品" min-width="200">
        <template slot-scope="scope">
          <el-cascader
            v-model="scope.row.goodsId"
            :options="goodsList"
            :props="{
              checkStrictly: true,
              value: 'value',
              label: 'label',
              children: 'children'
            }"
            placeholder="请选择商品"
            @change="(value) => handleGoodsChange(value, scope.$index)"
            clearable
          />
        </template>
      </el-table-column>
      <el-table-column label="数量" min-width="150">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.num"
            :min="1"
            :precision="0"
            @change="(value) => handleNumChange(value, scope.$index)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.$index)"
          />
        </template>
      </el-table-column>
    </el-table>
    
    <div class="add-button">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加商品</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CeilingProductSelector',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    goodsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedGoods: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectedGoods = val.map(item => ({
          goodsId: item.goodsId || [],
          num: item.num || 1
        }))
      }
    }
  },
  methods: {
    handleAdd() {
      this.selectedGoods.push({
        goodsId: [],
        num: 1
      })
      this.emitChange()
    },
    handleDelete(index) {
      this.selectedGoods.splice(index, 1)
      this.emitChange()
    },
    handleGoodsChange(value, index) {
      this.selectedGoods[index].goodsId = value
      this.emitChange()
    },
    handleNumChange(value, index) {
      this.selectedGoods[index].num = value
      this.emitChange()
    },
    emitChange() {
      this.$emit('input', this.selectedGoods)
      this.$emit('change', this.selectedGoods)
    }
  }
}
</script>

<style scoped>
.ceiling-product-selector {
  width: 100%;
}
.add-button {
  margin-top: 10px;
  text-align: center;
}
</style>
